module.exports = __webpack_public_path__ + "media/assets/brandLogo-02b2e8451040742c6258d40689ee4c9c.svg";